import React from "react";
import { useGeneralState } from "../../redux/general/selectors";
import { Role } from "../../redux/api-model/organization/company";
import { NotificationCardData } from "./notification";
import LinkStyled from "../buttonsLinks/LinkStyled";

type NotificationNameLinkProps = {
  data?: NotificationCardData;
};

export default function NotificationNameLink({
  data,
}: NotificationNameLinkProps): JSX.Element {
  const general = useGeneralState();

  if (data && data.firstName) {
    if (data.employeeId && data.workContractId) {
      const employeeLink =
        general.userSelection.type == Role.WORK_CONTRACT_ACCESS
          ? `/app/me/contract/${data.workContractId}`
          : `/app/employees/${data.employeeId}/contract/${data.workContractId}`;

      return (
        <LinkStyled to={employeeLink}>
          {data.firstName} {data.lastName}
        </LinkStyled>
      );
    }

    return (
      <span>
        {data.firstName} {data.lastName}
      </span>
    );
  }

  return <span></span>;
}
